import china from "@/assets/mapJson/data-city.json";
import neimengguzizhiqu from "@/assets/mapJson/data-neimenggu.json";
import beijing from "@/assets/mapJson/data-beijing.json";
import anhui from "@/assets/mapJson/data-anhui.json";
import aomen from "@/assets/mapJson/data-aomen.json";
import chongqing from "@/assets/mapJson/data-chongqing.json";
import fujian from "@/assets/mapJson/data-fujian.json";
import gansu from "@/assets/mapJson/data-gansu.json";
import guangdong from "@/assets/mapJson/data-guangdong.json";
import guangxi from "@/assets/mapJson/data-guangxi.json";
import guizhou from "@/assets/mapJson/data-guizhou.json";
import hainan from "@/assets/mapJson/data-hainan.json";
import hebei from "@/assets/mapJson/data-hebei.json";
import heilongjiang from "@/assets/mapJson/data-heilongjiang.json";
import henan from "@/assets/mapJson/data-henan.json";
import jiangsu from "@/assets/mapJson/data-jiangsu.json";
import jiangxi from "@/assets/mapJson/data-jiangxi.json";
import jilin from "@/assets/mapJson/data-jilin.json";
import liaoning from "@/assets/mapJson/data-liaoning.json";
import ningxia from "@/assets/mapJson/data-ningxia.json";
import qinghai from "@/assets/mapJson/data-qinghai.json";
import shandong from "@/assets/mapJson/data-shangdong.json";
import shanghai from "@/assets/mapJson/data-shanghai.json";
import hunan from "@/assets/mapJson/data-hunan.json";
import hubei from "@/assets/mapJson/420000.json";
import shangxi from "@/assets/mapJson/data-shangxi.json";
import shanxi from "@/assets/mapJson/data-shanxi.json";
import sichuan from "@/assets/mapJson/data-sichuan.json";
import tianjin from "@/assets/mapJson/data-tianjin.json";
import xianggang from "@/assets/mapJson/data-xianggang.json";
import xinjiang from "@/assets/mapJson/data-xinjiang.json";
import xizang from "@/assets/mapJson/data-xizang.json";
import yunnan from "@/assets/mapJson/data-yunnan.json";
import zhejiang from "@/assets/mapJson/data-zhejiang.json";
import C130100 from "@/assets/mapJson/130100.json";
import C130200 from "@/assets/mapJson/130200.json";
import C130300 from "@/assets/mapJson/130300.json";
import C130400 from "@/assets/mapJson/130400.json";
import C130500 from "@/assets/mapJson/130500.json";
import C130600 from "@/assets/mapJson/130600.json";
import C130700 from "@/assets/mapJson/130700.json";
import C130800 from "@/assets/mapJson/130800.json";
import C130900 from "@/assets/mapJson/130900.json";
import C131000 from "@/assets/mapJson/131000.json";
import C131100 from "@/assets/mapJson/131100.json";
import C140100 from "@/assets/mapJson/140100.json";
import C140200 from "@/assets/mapJson/140200.json";
import C140300 from "@/assets/mapJson/140300.json";
import C140400 from "@/assets/mapJson/140400.json";
import C140500 from "@/assets/mapJson/140500.json";
import C140600 from "@/assets/mapJson/140600.json";
import C140700 from "@/assets/mapJson/140700.json";
import C140800 from "@/assets/mapJson/140800.json";
import C140900 from "@/assets/mapJson/140900.json";
import C141000 from "@/assets/mapJson/141000.json";
import C141100 from "@/assets/mapJson/141100.json";
import C150100 from "@/assets/mapJson/150100.json";
import C150200 from "@/assets/mapJson/150200.json";
import C150300 from "@/assets/mapJson/150300.json";
import C150400 from "@/assets/mapJson/150400.json";
import C150500 from "@/assets/mapJson/150500.json";
import C150600 from "@/assets/mapJson/150600.json";
import C150700 from "@/assets/mapJson/150700.json";
import C150800 from "@/assets/mapJson/150800.json";
import C150900 from "@/assets/mapJson/150900.json";
import C152200 from "@/assets/mapJson/152200.json";
import C152500 from "@/assets/mapJson/152500.json";
import C152900 from "@/assets/mapJson/152900.json";
import C210100 from "@/assets/mapJson/210100.json";
import C210200 from "@/assets/mapJson/210200.json";
import C210300 from "@/assets/mapJson/210300.json";
import C210400 from "@/assets/mapJson/210400.json";
import C210500 from "@/assets/mapJson/210500.json";
import C210600 from "@/assets/mapJson/210600.json";
import C210700 from "@/assets/mapJson/210700.json";
import C210800 from "@/assets/mapJson/210800.json";
import C210900 from "@/assets/mapJson/210900.json";
import C211000 from "@/assets/mapJson/211000.json";
import C211100 from "@/assets/mapJson/211100.json";
import C211200 from "@/assets/mapJson/211200.json";
import C211300 from "@/assets/mapJson/211300.json";
import C211400 from "@/assets/mapJson/211400.json";
import C220100 from "@/assets/mapJson/220100.json";
import C220200 from "@/assets/mapJson/220200.json";
import C220300 from "@/assets/mapJson/220300.json";
import C220400 from "@/assets/mapJson/220400.json";
import C220500 from "@/assets/mapJson/220500.json";
import C220600 from "@/assets/mapJson/220600.json";
import C220700 from "@/assets/mapJson/220700.json";
import C220800 from "@/assets/mapJson/220800.json";
import C222400 from "@/assets/mapJson/222400.json";
import C230100 from "@/assets/mapJson/230100.json";
import C230200 from "@/assets/mapJson/230200.json";
import C230300 from "@/assets/mapJson/230300.json";
import C230400 from "@/assets/mapJson/230400.json";
import C230500 from "@/assets/mapJson/230500.json";
import C230600 from "@/assets/mapJson/230600.json";
import C230700 from "@/assets/mapJson/230700.json";
import C230800 from "@/assets/mapJson/230800.json";
import C230900 from "@/assets/mapJson/230900.json";
import C231000 from "@/assets/mapJson/231000.json";
import C231100 from "@/assets/mapJson/231100.json";
import C231200 from "@/assets/mapJson/231200.json";
import C232700 from "@/assets/mapJson/232700.json";
import C320100 from "@/assets/mapJson/320100.json";
import C320200 from "@/assets/mapJson/320200.json";
import C320300 from "@/assets/mapJson/320300.json";
import C320400 from "@/assets/mapJson/320400.json";
import C320500 from "@/assets/mapJson/320500.json";
import C320600 from "@/assets/mapJson/320600.json";
import C320700 from "@/assets/mapJson/320700.json";
import C320800 from "@/assets/mapJson/320800.json";
import C320900 from "@/assets/mapJson/320900.json";
import C321000 from "@/assets/mapJson/321000.json";
import C321100 from "@/assets/mapJson/321100.json";
import C321200 from "@/assets/mapJson/321200.json";
import C321300 from "@/assets/mapJson/321300.json";
import C330100 from "@/assets/mapJson/330100.json";
import C330200 from "@/assets/mapJson/330200.json";
import C330300 from "@/assets/mapJson/330300.json";
import C330400 from "@/assets/mapJson/330400.json";
import C330500 from "@/assets/mapJson/330500.json";
import C330600 from "@/assets/mapJson/330600.json";
import C330700 from "@/assets/mapJson/330700.json";
import C330800 from "@/assets/mapJson/330800.json";
import C330900 from "@/assets/mapJson/330900.json";
import C331000 from "@/assets/mapJson/331000.json";
import C331100 from "@/assets/mapJson/331100.json";
import C340100 from "@/assets/mapJson/340100.json";
import C340200 from "@/assets/mapJson/340200.json";
import C340300 from "@/assets/mapJson/340300.json";
import C340400 from "@/assets/mapJson/340400.json";
import C340500 from "@/assets/mapJson/340500.json";
import C340600 from "@/assets/mapJson/340600.json";
import C340700 from "@/assets/mapJson/340700.json";
import C340800 from "@/assets/mapJson/340800.json";
import C341000 from "@/assets/mapJson/341000.json";
import C341100 from "@/assets/mapJson/341100.json";
import C341200 from "@/assets/mapJson/341200.json";
import C341300 from "@/assets/mapJson/341300.json";
import C341500 from "@/assets/mapJson/341500.json";
import C341600 from "@/assets/mapJson/341600.json";
import C341700 from "@/assets/mapJson/341700.json";
import C341800 from "@/assets/mapJson/341800.json";
import C350100 from "@/assets/mapJson/350100.json";
import C350200 from "@/assets/mapJson/350200.json";
import C350300 from "@/assets/mapJson/350300.json";
import C350400 from "@/assets/mapJson/350400.json";
import C350500 from "@/assets/mapJson/350500.json";
import C350600 from "@/assets/mapJson/350600.json";
import C350700 from "@/assets/mapJson/350700.json";
import C350800 from "@/assets/mapJson/350800.json";
import C350900 from "@/assets/mapJson/350900.json";
import C360100 from "@/assets/mapJson/360100.json";
import C360200 from "@/assets/mapJson/360200.json";
import C360300 from "@/assets/mapJson/360300.json";
import C360400 from "@/assets/mapJson/360400.json";
import C360500 from "@/assets/mapJson/360500.json";
import C360600 from "@/assets/mapJson/360600.json";
import C360700 from "@/assets/mapJson/360700.json";
import C360800 from "@/assets/mapJson/360800.json";
import C360900 from "@/assets/mapJson/360900.json";
import C361000 from "@/assets/mapJson/361000.json";
import C361100 from "@/assets/mapJson/361100.json";
import C370100 from "@/assets/mapJson/370100.json";
import C370200 from "@/assets/mapJson/370200.json";
import C370300 from "@/assets/mapJson/370300.json";
import C370400 from "@/assets/mapJson/370400.json";
import C370500 from "@/assets/mapJson/370500.json";
import C370600 from "@/assets/mapJson/370600.json";
import C370700 from "@/assets/mapJson/370700.json";
import C370800 from "@/assets/mapJson/370800.json";
import C370900 from "@/assets/mapJson/370900.json";
import C371000 from "@/assets/mapJson/371000.json";
import C371100 from "@/assets/mapJson/371100.json";
import C371300 from "@/assets/mapJson/371300.json";
import C371400 from "@/assets/mapJson/371400.json";
import C371500 from "@/assets/mapJson/371500.json";
import C371600 from "@/assets/mapJson/371600.json";
import C371700 from "@/assets/mapJson/371700.json";
import C410100 from "@/assets/mapJson/410100.json";
import C410200 from "@/assets/mapJson/410200.json";
import C410300 from "@/assets/mapJson/410300.json";
import C410400 from "@/assets/mapJson/410400.json";
import C410500 from "@/assets/mapJson/410500.json";
import C410600 from "@/assets/mapJson/410600.json";
import C410700 from "@/assets/mapJson/410700.json";
import C410800 from "@/assets/mapJson/410800.json";
import C410900 from "@/assets/mapJson/410900.json";
import C411000 from "@/assets/mapJson/411000.json";
import C411100 from "@/assets/mapJson/411100.json";
import C411200 from "@/assets/mapJson/411200.json";
import C411300 from "@/assets/mapJson/411300.json";
import C411400 from "@/assets/mapJson/411400.json";
import C411500 from "@/assets/mapJson/411500.json";
import C411600 from "@/assets/mapJson/411600.json";
import C411700 from "@/assets/mapJson/411700.json";
import C420100 from "@/assets/mapJson/420100.json";
import C420200 from "@/assets/mapJson/420200.json";
import C420300 from "@/assets/mapJson/420300.json";
import C420500 from "@/assets/mapJson/420500.json";
import C420600 from "@/assets/mapJson/420600.json";
import C420700 from "@/assets/mapJson/420700.json";
import C420800 from "@/assets/mapJson/420800.json";
import C420900 from "@/assets/mapJson/420900.json";
import C421000 from "@/assets/mapJson/421000.json";
import C421100 from "@/assets/mapJson/421100.json";
import C421200 from "@/assets/mapJson/421200.json";
import C422800 from "@/assets/mapJson/422800.json";
import C430100 from "@/assets/mapJson/430100.json";
import C430200 from "@/assets/mapJson/430200.json";
import C430300 from "@/assets/mapJson/430300.json";
import C430400 from "@/assets/mapJson/430400.json";
import C430500 from "@/assets/mapJson/430500.json";
import C430600 from "@/assets/mapJson/430600.json";
import C430700 from "@/assets/mapJson/430700.json";
import C430800 from "@/assets/mapJson/430800.json";
import C430900 from "@/assets/mapJson/430900.json";
import C431000 from "@/assets/mapJson/431000.json";
import C431100 from "@/assets/mapJson/431100.json";
import C431200 from "@/assets/mapJson/431200.json";
import C431300 from "@/assets/mapJson/431300.json";
import C440100 from "@/assets/mapJson/440100.json";
import C440200 from "@/assets/mapJson/440200.json";
import C440300 from "@/assets/mapJson/440300.json";
import C440400 from "@/assets/mapJson/440400.json";
import C440500 from "@/assets/mapJson/440500.json";
import C440600 from "@/assets/mapJson/440600.json";
import C440700 from "@/assets/mapJson/440700.json";
import C440800 from "@/assets/mapJson/440800.json";
import C440900 from "@/assets/mapJson/440900.json";
import C441200 from "@/assets/mapJson/441200.json";
import C441300 from "@/assets/mapJson/441300.json";
import C441400 from "@/assets/mapJson/441400.json";
import C441500 from "@/assets/mapJson/441500.json";
import C441600 from "@/assets/mapJson/441600.json";
import C441700 from "@/assets/mapJson/441700.json";
import C441800 from "@/assets/mapJson/441800.json";
//import C442000 from "@/assets/mapJson/442000.json";
import C445100 from "@/assets/mapJson/445100.json";
import C445200 from "@/assets/mapJson/445200.json";
import C445300 from "@/assets/mapJson/445300.json";
import C450100 from "@/assets/mapJson/450100.json";
import C450200 from "@/assets/mapJson/450200.json";
import C450300 from "@/assets/mapJson/450300.json";
import C450400 from "@/assets/mapJson/450400.json";
import C450500 from "@/assets/mapJson/450500.json";
import C450600 from "@/assets/mapJson/450600.json";
import C450700 from "@/assets/mapJson/450700.json";
import C450800 from "@/assets/mapJson/450800.json";
import C450900 from "@/assets/mapJson/450900.json";
import C451000 from "@/assets/mapJson/451000.json";
import C451100 from "@/assets/mapJson/451100.json";
import C451200 from "@/assets/mapJson/451200.json";
import C451300 from "@/assets/mapJson/451300.json";
import C451400 from "@/assets/mapJson/451400.json";
import C460100 from "@/assets/mapJson/460100.json";
import C460200 from "@/assets/mapJson/460200.json";
import C460300 from "@/assets/mapJson/460300.json";
//import C460400 from "@/assets/mapJson/460400.json";
import C510100 from "@/assets/mapJson/510100.json";
import C510300 from "@/assets/mapJson/510300.json";
import C510400 from "@/assets/mapJson/510400.json";
import C510500 from "@/assets/mapJson/510500.json";
import C510600 from "@/assets/mapJson/510600.json";
import C510700 from "@/assets/mapJson/510700.json";
import C510800 from "@/assets/mapJson/510800.json";
import C510900 from "@/assets/mapJson/510900.json";
import C511000 from "@/assets/mapJson/511000.json";
import C511100 from "@/assets/mapJson/511100.json";
import C511300 from "@/assets/mapJson/511300.json";
import C511400 from "@/assets/mapJson/511400.json";
import C511500 from "@/assets/mapJson/511500.json";
import C511600 from "@/assets/mapJson/511600.json";
import C511700 from "@/assets/mapJson/511700.json";
import C511800 from "@/assets/mapJson/511800.json";
import C511900 from "@/assets/mapJson/511900.json";
import C512000 from "@/assets/mapJson/512000.json";
import C513200 from "@/assets/mapJson/513200.json";
import C513300 from "@/assets/mapJson/513300.json";
import C513400 from "@/assets/mapJson/513400.json";
import C520100 from "@/assets/mapJson/520100.json";
import C520200 from "@/assets/mapJson/520200.json";
import C520300 from "@/assets/mapJson/520300.json";
import C520400 from "@/assets/mapJson/520400.json";
import C520500 from "@/assets/mapJson/520500.json";
import C520600 from "@/assets/mapJson/520600.json";
import C522300 from "@/assets/mapJson/522300.json";
import C522600 from "@/assets/mapJson/522600.json";
import C522700 from "@/assets/mapJson/522700.json";
import C530100 from "@/assets/mapJson/530100.json";
import C530300 from "@/assets/mapJson/530300.json";
import C530400 from "@/assets/mapJson/530400.json";
import C530500 from "@/assets/mapJson/530500.json";
import C530600 from "@/assets/mapJson/530600.json";
import C530700 from "@/assets/mapJson/530700.json";
import C530800 from "@/assets/mapJson/530800.json";
import C530900 from "@/assets/mapJson/530900.json";
import C532300 from "@/assets/mapJson/532300.json";
import C532500 from "@/assets/mapJson/532500.json";
import C532600 from "@/assets/mapJson/532600.json";
import C532800 from "@/assets/mapJson/532800.json";
import C532900 from "@/assets/mapJson/532900.json";
import C533100 from "@/assets/mapJson/533100.json";
import C533300 from "@/assets/mapJson/533300.json";
import C533400 from "@/assets/mapJson/533400.json";
import C540100 from "@/assets/mapJson/540100.json";
import C540200 from "@/assets/mapJson/540200.json";
import C540300 from "@/assets/mapJson/540300.json";
import C540400 from "@/assets/mapJson/540400.json";
import C540500 from "@/assets/mapJson/540500.json";
//import C542400 from "@/assets/mapJson/542400.json";
import C542500 from "@/assets/mapJson/542500.json";
import C610100 from "@/assets/mapJson/610100.json";
import C610200 from "@/assets/mapJson/610200.json";
import C610300 from "@/assets/mapJson/610300.json";
import C610400 from "@/assets/mapJson/610400.json";
import C610500 from "@/assets/mapJson/610500.json";
import C610600 from "@/assets/mapJson/610600.json";
import C610700 from "@/assets/mapJson/610700.json";
import C610800 from "@/assets/mapJson/610800.json";
import C610900 from "@/assets/mapJson/610900.json";
import C611000 from "@/assets/mapJson/611000.json";
import C620100 from "@/assets/mapJson/620100.json";
import C620200 from "@/assets/mapJson/620200.json";
import C620300 from "@/assets/mapJson/620300.json";
import C620400 from "@/assets/mapJson/620400.json";
import C620500 from "@/assets/mapJson/620500.json";
import C620600 from "@/assets/mapJson/620600.json";
import C620700 from "@/assets/mapJson/620700.json";
import C620800 from "@/assets/mapJson/620800.json";
import C620900 from "@/assets/mapJson/620900.json";
import C621000 from "@/assets/mapJson/621000.json";
import C621100 from "@/assets/mapJson/621100.json";
import C621200 from "@/assets/mapJson/621200.json";
import C622900 from "@/assets/mapJson/622900.json";
import C623000 from "@/assets/mapJson/623000.json";
import C630100 from "@/assets/mapJson/630100.json";
import C630200 from "@/assets/mapJson/630200.json";
import C632300 from "@/assets/mapJson/632300.json";
import C632500 from "@/assets/mapJson/632500.json";
import C632600 from "@/assets/mapJson/632600.json";
import C632700 from "@/assets/mapJson/632700.json";
import C632800 from "@/assets/mapJson/632800.json";
import C640100 from "@/assets/mapJson/640100.json";
import C640200 from "@/assets/mapJson/640200.json";
import C640300 from "@/assets/mapJson/640300.json";
import C640400 from "@/assets/mapJson/640400.json";
import C640500 from "@/assets/mapJson/640500.json";
import C650100 from "@/assets/mapJson/650100.json";
import C650200 from "@/assets/mapJson/650200.json";
import C650400 from "@/assets/mapJson/650400.json";
import C650500 from "@/assets/mapJson/650500.json";
import C652300 from "@/assets/mapJson/652300.json";
import C652700 from "@/assets/mapJson/652700.json";
import C652800 from "@/assets/mapJson/652800.json";
import C652900 from "@/assets/mapJson/652900.json";
import C653000 from "@/assets/mapJson/653000.json";
import C653100 from "@/assets/mapJson/653100.json";
import C653200 from "@/assets/mapJson/653200.json";
import C654000 from "@/assets/mapJson/654000.json";
import C654200 from "@/assets/mapJson/654200.json";
import C654300 from "@/assets/mapJson/654300.json";
//import C710000 from "@/assets/mapJson/710000.json";
import C710100 from "@/assets/mapJson/710100.json";
import C710200 from "@/assets/mapJson/710200.json";
import C710300 from "@/assets/mapJson/710300.json";
//import C710400 from "@/assets/mapJson/710400.json";
import C710600 from "@/assets/mapJson/710600.json";
import C710700 from "@/assets/mapJson/710700.json";
import C710800 from "@/assets/mapJson/710800.json";
import C710900 from "@/assets/mapJson/710900.json";
// import C711100 from "@/assets/mapJson/711100.json";
// import C711200 from "@/assets/mapJson/711200.json";
// import C711300 from "@/assets/mapJson/711300.json";
// import C711400 from "@/assets/mapJson/711400.json";
// import C711500 from "@/assets/mapJson/711500.json";
// import C711700 from "@/assets/mapJson/711700.json";
// import C711900 from "@/assets/mapJson/711900.json";
// import C712100 from "@/assets/mapJson/712100.json";
// //import C712400 from "@/assets/mapJson/712400.json";
// import C712500 from "@/assets/mapJson/712500.json";
// import C712600 from "@/assets/mapJson/712600.json";
// import C712700 from "@/assets/mapJson/712700.json";
// import C810000 from "@/assets/mapJson/810000.json";
// import C820000 from "@/assets/mapJson/820000.json";

const mapDict = {
  中国: "china",
  安徽: "anhui",
  北京: "beijing",
  内蒙古: "neimengguzizhiqu",
  澳门: "aomen",
  重庆: "chongqing",
  福建: "fujian",
  甘肃: "gansu",
  广东: "guangdong",
  广西: "guangxi",
  贵州: "guizhou",
  海南: "hainan",
  河北: "hebei",
  黑龙江: "heilongjiang",
  河南: "henan",
  江苏: "jiangsu",
  江西: "jiangxi",
  吉林: "jilin",
  辽宁: "liaoning",
  宁夏: "ningxia",
  青海: "qinghai",
  山东: "shandong",
  上海: "shanghai",
  山西: "shangxi",
  陕西: "shanxi",
  四川: "sichuan",
  天津: "tianjin",
  香港: "xianggang",
  新疆: "xinjiang",
  西藏: "xizang",
  云南: "yunnan",
  浙江: "zhejiang",
  湖北: "hubei",
  湖南: "hunan",
  石家庄市 : "C130100",
  唐山市 : "C130200",
  秦皇岛市 : "C130300",
  邯郸市 : "C130400",
  邢台市 : "C130500",
  保定市 : "C130600",
  张家口市 : "C130700",
  承德市 : "C130800",
  沧州市 : "C130900",
  廊坊市 : "C131000",
  衡水市 : "C131100",
  太原市 : "C140100",
  大同市 : "C140200",
  阳泉市 : "C140300",
  长治市 : "C140400",
  晋城市 : "C140500",
  朔州市 : "C140600",
  晋中市 : "C140700",
  运城市 : "C140800",
  忻州市 : "C140900",
  临汾市 : "C141000",
  吕梁市 : "C141100",
  呼和浩特市 : "C150100",
  包头市  : "C150200",
  乌海市 : "C150300",
  赤峰市 : "C150400",
  通辽市 : "C150500",
  鄂尔多斯市 : "C150600",
  呼伦贝尔市 : "C150700",
  巴彦淖尔市 : "C150800",
  乌兰察布市 : "C150900",
  兴安盟 : "C152200",
  锡林郭勒盟 : "C152500",
  阿拉善盟 : "C152900",
  沈阳市 : "C210100",
  大连市 : "C210200",
  鞍山市族自治县 : "C210300",
  抚顺市 : "C210400",
  本溪市 : "C210500",
  丹东市 : "C210600",
  锦州市 : "C210700",
  营口市 : "C210800",
  阜新市 : "C210900",
  辽阳市 : "C211000",
  盘锦市 : "C211100",
  铁岭市 : "C211200",
  朝阳市	  : "C211300",
  葫芦岛市 : "C211400",
  长春市  : "C220100",
  吉林市	  : "C220200",
  四平市 : "C220300",
  辽源市 : "C220400",
  通化市	  : "C220500",
  白山市 : "C220600",
  松原市 : "C220700",
  白城市 : "C220800",
  延边朝鲜族自治州: "C222400",
  哈尔滨市  : "C230100",
  齐齐哈尔市  : "C230200",
  鸡西市  : "C230300",
  鹤岗市 : "C230400",
  双鸭山市  : "C230500",
  大庆市    : "C230600",
  伊春市 : "C230700",
  佳木斯市 : "C230800",
  七台河市 : "C230900",
  牡丹江市 : "C231000",
  黑河市 : "C231100",
  绥化市 : "C231200",
  大兴安岭地区   : "C232700",
  南京市 : "C320100",
  无锡市 : "C320200",
  徐州市 : "C320300",
  常州市 : "C320400",
  苏州市 : "C320500",
  南通市 : "C320600",
  连云港市 : "C320700",
  淮安市 : "C320800",
  盐城市 : "C320900",
  扬州市 : "C321000",
  镇江市 : "C321100",
  泰州市 : "C321200",
  宿迁市 : "C321300",
  杭州市 : "C330100",
  宁波市 : "C330200",
  温州市 : "C330300",
  嘉兴市 : "C330400",
  湖州市 : "C330500",
  绍兴市 : "C330600",
  金华市 : "C330700",
  衢州市  : "C330800",
  舟山市	  : "C330900",
  台州市  : "C331000",
  丽水市  : "C331100",
  合肥市    : "C340100",
  芜湖市 : "C340200",
  蚌埠市	  : "C340300",
  淮南市 : "C340400",
  马鞍山市 : "C340500",
  淮北市 : "C340600",
  铜陵市	  : "C340700",
  安庆市 : "C340800",
  黄山市 : "C341000",
  滁州市 : "C341100",
  阜阳市 : "C341200",
  宿州市 : "C341300",
  六安市 : "C341500",
  亳州市 : "C341600",
  池州市    : "C341700",
  宣城市	  : "C341800",
  福州市 : "C350100",
  厦门市 : "C350200",
  莆田市  : "C350300",
  三明市	  : "C350400",
  泉州市	  : "C350500",
  漳州市  : "C350600",
  南平市    : "C350700",
  龙岩市 : "C350800",
  宁德市  : "C350900",
  南昌市  : "C360100",
  景德镇市 : "C360200",
  萍乡市    : "C360300",
  九江市    : "C360400",
  新余市 : "C360500",
  鹰潭市  : "C360600",
  赣州市	  : "C360700",
  吉安市    : "C360800",
  宜春市    : "C360900",
  抚州市 : "C361000",
  上饶市    : "C361100",
  济南市	  : "C370100",
  青岛市    : "C370200",
  淄博市  : "C370300",
  枣庄市 : "C370400",
  东营市  : "C370500",
  烟台市  : "C370600",
  潍坊市    : "C370700",
  济宁市	  : "C370800",
  泰安市	  : "C370900",
  威海市    : "C371000",
  日照市    : "C371100",
  临沂市  : "C371300",
  德州市    : "C371400",
  聊城市	  : "C371500",
  滨州市 : "C371600",
  菏泽市  : "C371700",
  郑州市  : "C410100",
  开封市	  : "C410200",
  洛阳市    : "C410300",
  平顶山市  : "C410400",
  安阳市 : "C410500",
  鹤壁市  : "C410600",
  新乡市	  : "C410700",
  焦作市  : "C410800",
  濮阳市 : "C410900",
  许昌市	  : "C411000",
  漯河市    : "C411100",
  三门峡市  : "C411200",
  南阳市	  : "C411300",
  商丘市  : "C411400",
  信阳市    : "C411500",
  周口市  : "C411600",
  驻马店市  : "C411700",
  武汉市	  : "C420100",
  黄石市 : "C420200",
  十堰市  : "C420300",
  宜昌市  : "C420500",
  襄阳市 : "C420600",
  鄂州市 : "C420700",
  荆门市 : "C420800",
  孝感市 : "C420900",
  荆州市 : "C421000",
  黄冈市 : "C421100",
  咸宁市 : "C421200",
  恩施土家族苗族自治州    : "C422800",
  长沙市  : "C430100",
  株洲市	  : "C430200",
  湘潭市	  : "C430300",
  衡阳市    : "C430400",
  邵阳市    : "C430500",
  岳阳市	  : "C430600",
  常德市    : "C430700",
  张家界市 : "C430800",
  益阳市  : "C430900",
  郴州市 : "C431000",
  永州市	 : "C431100",
  怀化市	  : "C431200",
  娄底市 : "C431300",
  广州市 : "C440100",
  韶关市 : "C440200",
  深圳市 : "C440300",
  珠海市 : "C440400",
  汕头市 : "C440500",
  佛山市 : "C440600",
  江门市 : "C440700",
  湛江市 : "C440800",
  茂名市 : "C440900",
  肇庆市 : "C441200",
  惠州市 : "C441300",
  梅州市 : "C441400",
  汕尾市  : "C441500",
  河源市	  : "C441600",
  阳江市	  : "C441700",
  清远市    : "C441800",
  //中山市 : "C442000",
  潮州市   : "C445100",
  揭阳市  : "C445200",
  云浮市  : "C445300",
  南宁市 : "C450100",
  柳州市    : "C450200",
  桂林市    : "C450300",
  梧州市	  : "C450400",
  北海市    : "C450500",
  防城港市 : "C450600",
  钦州市  : "C450700",
  贵港市	  : "C450800",
  玉林市    : "C450900",
  百色市 : "C451000",
  贺州市 : "C451100",
  河池市 : "C451200",
  来宾市 : "C451300",
  崇左市    : "C451400",
  海口市 : "C460100",
  三亚市 : "C460200",
  三沙市 : "C460300",
  //儋州市  : "C460400",
  成都市 : "C510100",
  自贡市 : "C510300",
  攀枝花市 : "C510400",
  泸州市 : "C510500",
  德阳市  : "C510600",
  绵阳市 : "C510700",
  广元市 : "C510800",
  遂宁市    : "C510900",
  内江市  : "C511000",
  乐山市  : "C511100",
  南充市	  : "C511300",
  眉山市  : "C511400",
  宜宾市  : "C511500",
  广安市  : "C511600",
  达州市  : "C511700",
  雅安市 : "C511800",
  巴中市	  : "C511900",
  资阳市	  : "C512000",
  阿坝藏族羌族自治州     : "C513200",
  甘孜藏族自治州 : "C513300",
  凉山彝族自治州    : "C513400",
  贵阳市  : "C520100",
  六盘水市  : "C520200",
  遵义市  : "C520300",
  安顺市    : "C520400",
  毕节市    : "C520500",
  铜仁市    : "C520600",
  黔西南布依族苗族自治    : "C522300",
  黔东南苗族侗族自治州    : "C522600",
  黔南布依族苗族自治州    : "C522700",
  昆明市 : "C530100",
  曲靖市 : "C530300",
  玉溪市 : "C530400",
  保山市 : "C530500",
  昭通市 : "C530600",
  丽江市 : "C530700",
  普洱市 : "C530800",
  临沧市 : "C530900",
  楚雄彝族自治州 : "C532300",
  红河哈尼族彝族自治州    : "C532500",
  文山壮族苗族自治州     : "C532600",
  西双版纳傣族自治州     : "C532800",
  大理白族自治州 : "C532900",
  德宏傣族景颇族自治州    : "C533100",
  怒江傈僳族自治州   : "C533300",
  迪庆藏族自治州 : "C533400",
  拉萨市    : "C540100",
  日喀则市  : "C540200",
  昌都市  : "C540300",
  林芝市  : "C540400",
  山南市    : "C540500",
 // 那曲地区  : "C542400",
  阿里地区 : "C542500",
  西安市    : "C610100",
  铜川市 : "C610200",
  宝鸡市	  : "C610300",
  咸阳市	  : "C610400",
  渭南市	  : "C610500",
  延安市  : "C610600",
  汉中市 : "C610700",
  榆林市 : "C610800",
  安康市    : "C610900",
  商洛市 : "C611000",
  兰州市    : "C620100",
  嘉峪关市 : "C620200",
  金昌市 : "C620300",
  白银市 : "C620400",
  天水市 : "C620500",
  武威市 : "C620600",
  张掖市 : "C620700",
  平凉市 : "C620800",
  酒泉市 : "C620900",
  庆阳市 : "C621000",
  定西市 : "C621100",
  陇南市 : "C621200",
  临夏回族自治州 : "C622900",
  甘南藏族自治州 : "C623000",
  西宁市	  : "C630100",
  海东市    : "C630200",
  黄南藏族自治州 : "C632300",
  海南藏族自治州 : "C632500",
  果洛藏族自治州 : "C632600",
  玉树藏族自治州 : "C632700",
  海西蒙古族藏族自治州    : "C632800",
  银川市 : "C640100",
  石嘴山市 : "C640200",
  吴忠市 : "C640300",
  固原市 : "C640400",
  中卫市 : "C640500",
  乌鲁木齐市 : "C650100",
  克拉玛依市 : "C650200",
  吐鲁番市 : "C650400",
  哈密市 : "C650500",
  昌吉回族自治州 : "C652300",
  博尔塔拉蒙古自治州     : "C652700",
  巴音郭楞蒙古自治州     : "C652800",
  阿克苏地区  : "C652900",
  克孜勒苏柯尔克孜自治    : "C653000",
  喀什地区 : "C653100",
  和田地区   : "C653200",
  伊犁哈萨克自治州   : "C654000",
  塔城地区 : "C654200",
  阿勒泰地区 : "C654300",
  //石河子市    : "C659001",
  //台湾省   : "C710000",
  台北市  : "C710100",
  高雄市  : "C710200",
  台南市  : "C710300",
  //台中市  : "C710400",
  南投县  : "C710600",
  基隆市    : "C710700",
  新竹市  : "C710800",
  嘉义市    : "C710900",
  // 新北市 : "C711100",
  // 宜兰县 : "C711200",
  // 新竹县 : "C711300",
  // 桃园市 : "C711400",
  // 苗栗县 : "C711500",
  // 彰化县 : "C711700",
  // 嘉义县 : "C711900",
  // 云林县 : "C712100",
  // 屏东县 : "C712400",
  // 台东县 : "C712500",
  // 花莲县 : "C712600",
  // 澎湖县 : "C712700",
  // 香港特别行政区 : "C810000",
  // 澳门特别行政区 : "C820000",
};

const mapData = {
  china,
  beijing,
  neimengguzizhiqu,
  anhui,
  aomen,
  chongqing,
  fujian,
  gansu,
  guangdong,
  guangxi,
  guizhou,
  hainan,
  hebei,
  heilongjiang,
  henan,
  jiangsu,
  jiangxi,
  jilin,
  liaoning,
  ningxia,
  qinghai,
  shandong,
  shanghai,
  shangxi,
  shanxi,
  sichuan,
  tianjin,
  xianggang,
  xinjiang,
  xizang,
  yunnan,
  zhejiang,
  hubei,
  hunan,
  C130200,
  C130300,
  C130400,
  C130500,
  C130600,
  C130700,
  C130800,
  C130900,
  C131000,
  C131100,
  C140100,
  C140200,
  C140300,
  C140400,
  C140500,
  C140600,
  C140700,
  C140800,
  C140900,
  C141000,
  C141100,
  C150100,
  C150200,
  C150300,
  C150400,
  C150500,
  C150600,
  C150700,
  C150800,
  C150900,
  C152200,
  C152500,
  C152900,
  C210100,
  C210200,
  C210300,
  C210400,
  C210500,
  C210600,
  C210700,
  C210800,
  C210900,
  C211000,
  C211100,
  C211200,
  C211300,
  C211400,
  C220100,
  C220200,
  C220300,
  C220400,
  C220500,
  C220600,
  C220700,
  C220800,
  C222400,
  C230100,
  C230200,
  C230300,
  C230400,
  C230500,
  C230600,
  C230700,
  C230800,
  C230900,
  C231000,
  C231100,
  C231200,
  C232700,
  C320100,
  C320200,
  C320300,
  C320400,
  C320500,
  C320600,
  C320700,
  C320800,
  C320900,
  C321000,
  C321100,
  C321200,
  C321300,
  C330100,
  C330200,
  C330300,
  C330400,
  C330500,
  C330600,
  C330700,
  C330800,
  C330900,
  C331000,
  C331100,
  C340100,
  C340200,
  C340300,
  C340400,
  C340500,
  C340600,
  C340700,
  C340800,
  C341000,
  C341100,
  C341200,
  C341300,
  C341500,
  C341600,
  C341700,
  C341800,
  C350100,
  C350200,
  C350300,
  C350400,
  C350500,
  C350600,
  C350700,
  C350800,
  C350900,
  C360100,
  C360200,
  C360300,
  C360400,
  C360500,
  C360600,
  C360700,
  C360800,
  C360900,
  C361000,
  C361100,
  C370100,
  C370200,
  C370300,
  C370400,
  C370500,
  C370600,
  C370700,
  C370800,
  C370900,
  C371000,
  C371100,
  C371300,
  C371400,
  C371500,
  C371600,
  C371700,
  C410100,
  C410200,
  C410300,
  C410400,
  C410500,
  C410600,
  C410700,
  C410800,
  C410900,
  C411000,
  C411100,
  C411200,
  C411300,
  C411400,
  C411500,
  C411600,
  C411700,
  C420100,
  C420200,
  C420300,
  C420500,
  C420600,
  C420700,
  C420800,
  C420900,
  C421000,
  C421100,
  C421200,
  C422800,
  C430100,
  C430200,
  C430300,
  C430400,
  C430500,
  C430600,
  C430700,
  C430800,
  C430900,
  C431000,
  C431100,
  C431200,
  C431300,
  C440100,
  C440200,
  C440300,
  C440400,
  C440500,
  C440600,
  C440700,
  C440800,
  C440900,
  C441200,
  C441300,
  C441400,
  C441500,
  C441600,
  C441700,
  C441800,
  //C442000,
  C445100,
  C445200,
  C445300,
  C450100,
  C450200,
  C450300,
  C450400,
  C450500,
  C450600,
  C450700,
  C450800,
  C450900,
  C451000,
  C451100,
  C451200,
  C451300,
  C451400,
  C460100,
  C460200,
  C460300,
  //C460400,
  C510100,
  C510300,
  C510400,
  C510500,
  C510600,
  C510700,
  C510800,
  C510900,
  C511000,
  C511100,
  C511300,
  C511400,
  C511500,
  C511600,
  C511700,
  C511800,
  C511900,
  C512000,
  C513200,
  C513300,
  C513400,
  C520100,
  C520200,
  C520300,
  C520400,
  C520500,
  C520600,
  C522300,
  C522600,
  C522700,
  C530100,
  C530300,
  C530400,
  C530500,
  C530600,
  C530700,
  C530800,
  C530900,
  C532300,
  C532500,
  C532600,
  C532800,
  C532900,
  C533100,
  C533300,
  C533400,
  C540100,
  C540200,
  C540300,
  C540400,
  C540500,
  //C542400,
  C542500,
  C610100,
  C610200,
  C610300,
  C610400,
  C610500,
  C610600,
  C610700,
  C610800,
  C610900,
  C611000,
  C620100,
  C620200,
  C620300,
  C620400,
  C620500,
  C620600,
  C620700,
  C620800,
  C620900,
  C621000,
  C621100,
  C621200,
  C622900,
  C623000,
  C630100,
  C630200,
  C632300,
  C632500,
  C632600,
  C632700,
  C632800,
  C640100,
  C640200,
  C640300,
  C640400,
  C640500,
  C650100,
  C650200,
  C650400,
  C650500,
  C652300,
  C652700,
  C652800,
  C652900,
  C653000,
  C653100,
  C653200,
  C654000,
  C654200,
  C654300,
 // C659001,
  //C710000,
  C710100,
  C710200,
  C710300,
  //C710400,
  C710600,
  C710700,
  C710800,
  C710900,
  // C711100,
  // C711200,
  // C711300,
  // C711400,
  // C711500,
  // C711700,
  // C711900,
  // C712100,
  // C712400,
  // C712500,
  // C712600,
  // C712700,
  // C810000
};

export function getMap(mapName) {
  const cityName = mapDict[mapName];
  if (cityName) {
    return [cityName, mapData[cityName]];
  }
  return [null, null];
}
